import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiAlertTriangle, FiRefreshCw, FiSettings, FiDatabase, FiTool } = FiIcons;

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-3 z-10">
      <div className="flex items-center justify-between">
        {/* Logo and Title */}
        <Link to="/" className="flex items-center space-x-3">
          <div className="bg-blue-600 p-2 rounded-lg">
            <SafeIcon icon={FiZap} className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Rebrand Studio</h1>
            <p className="text-xs text-gray-500">Professional Document Rebranding</p>
          </div>
        </Link>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          <Link to="/debug/brand-kit-debugger">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center px-4 py-2 text-sm-blue-800 bg-blue-100 border border-blue-300 rounded-md hover:bg-blue-200 transition-colors"
            >
              <SafeIcon icon={FiTool} className="w-4 h-4 mr-2" />
              Brand Kit Debugger
            </motion.button>
          </Link>
          <Link to="/debug/ncb-tester">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center px-4 py-2 text-sm text-green-800 bg-green-100 border border-green-300 rounded-md hover:bg-green-200 transition-colors"
            >
              <SafeIcon icon={FiDatabase} className="w-4 h-4 mr-2" />
              NCB Tester
            </motion.button>
          </Link>
          <Link to="/debug/dropbox-tester">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center px-4 py-2 text-sm-blue-800 bg-blue-100 border border-blue-300 rounded-md hover:bg-blue-200 transition-colors"
            >
              <SafeIcon icon={FiDatabase} className="w-4 h-4 mr-2" />
              Dropbox Test
            </motion.button>
          </Link>
          <Link to="/debug/upload-tester">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center px-4 py-2 text-sm text-yellow-800 bg-yellow-100 border border-yellow-300 rounded-md hover:bg-yellow-200 transition-colors"
            >
              <SafeIcon icon={FiAlertTriangle} className="w-4 h-4 mr-2" />
              Debug Uploads
            </motion.button>
          </Link>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            <SafeIcon icon={FiRefreshCw} className="w-4 h-4 mr-2" />
            Refresh
          </motion.button>
          <Link to="/brand-kit">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              <SafeIcon icon={FiSettings} className="w-4 h-4 mr-2" />
              Manage Brand Kits
            </motion.button>
          </Link>
          <Link to="/process">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
            >
              Process Document
            </motion.button>
          </Link>
        </div>
      </div>
    </header>
  );
}